// extracted by mini-css-extract-plugin
module.exports = {"ttContent":"cell_ttContent__2euPb","colorChange":"cell_colorChange__22Zev"};